(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-formulation"]) return;
  try {
    
	function handleListItemHover(action, item) {
		item.addEventListener(
			action,
			function (e) {
				const target = document.querySelector(
					`.image-item[data-block-id="${e.target.dataset.blockId}"]`
				);

				if (action === 'mouseleave') {
					target.classList.remove('is-active');
					return;
				}

				target.classList.add('is-active');
			},
			false
		);
	}

	document.querySelectorAll('.ingredient-list li').forEach((item) => {
		handleListItemHover('mouseenter', item);
		handleListItemHover('mouseleave', item);
	});

  } catch(e) { console.error(e); }
})();
})();
